"use client";

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["colorVariant", "fillVariant", "fullWidth", "hasChevron", "loading", "leftIcon", "rightIcon", "children"];
import React from "react";
import { StyledButton, FlexWrapper, Text, LoadingContainer } from "./index.styles";
import ChevronIcon from "../../icons/dist/ChevronIcon";
import { Spinner } from "../shared/Spinner";
import VisuallyHidden from "../utils/VisuallyHidden";
import { getButtonType } from "../../utils/getButtonType";
var BaseButton = function BaseButton(props) {
  var _props$colorVariant = props.colorVariant,
    colorVariant = _props$colorVariant === void 0 ? "primary" : _props$colorVariant,
    _props$fillVariant = props.fillVariant,
    fillVariant = _props$fillVariant === void 0 ? "fill" : _props$fillVariant,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    _props$hasChevron = props.hasChevron,
    hasChevron = _props$hasChevron === void 0 ? false : _props$hasChevron,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? null : _props$loading,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var getFillVariant = function getFillVariant() {
    var outlineColorVariants = ["secondary", "tertiary", "inverse"];
    if (outlineColorVariants.includes(colorVariant)) {
      return "outline";
    }
    return fillVariant;
  };
  var getLoadingColorVariant = function getLoadingColorVariant() {
    if (colorVariant === "primary" && fillVariant !== "fill" || colorVariant === "secondary") {
      return "primary";
    }
    if (colorVariant === "tertiary") {
      return "secondary";
    }
    return "inverse";
  };
  var showLoadingState = (loading === null || loading === void 0 ? void 0 : loading.isLoading) && !(props.disabled || props["aria-disabled"] === "true");
  var sharedProps = {
    $colorVariant: colorVariant,
    $fillVariant: getFillVariant(),
    $fullWidth: fullWidth,
    $leftIcon: leftIcon,
    $rightIcon: hasChevron || rightIcon,
    $showLoadingState: showLoadingState,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FlexWrapper, {
      $isLoading: showLoadingState
    }, leftIcon, /*#__PURE__*/React.createElement(Text, {
      $spaceLeft: !!leftIcon,
      $spaceRight: !!(hasChevron || rightIcon)
    }, children), hasChevron ? /*#__PURE__*/React.createElement(ChevronIcon, {
      rotate: -90,
      size: "1.5em"
    }) : rightIcon), loading && /*#__PURE__*/React.createElement(VisuallyHidden, {
      "aria-live": "assertive",
      role: "status"
    }, showLoadingState && loading.hiddenLoadingMessage), showLoadingState && /*#__PURE__*/React.createElement(LoadingContainer, null, /*#__PURE__*/React.createElement(Spinner, {
      colorVariant: getLoadingColorVariant()
    })))
  };

  // Conditionally set href to undefined when [aria-disabled="true"]
  var href = props["aria-disabled"] === "true" ? undefined : props.href;
  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, rest, sharedProps, {
    type: getButtonType(props),
    href: href
  }));
};
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    // @ts-expect-error - I'm not sure how to fix the ref type
    React.createElement(BaseButton, _extends({}, props, {
      ref: ref
    }))
  );
});
export default Button;